import React, { useContext } from 'react';

import { Color } from '../types/theme';
import { getContrastingTextColor } from '../utils/hex-to-rgb';
import { GameDocumentContext } from '../contexts/game-document';

const Theme = () => {
  const [gameDocument] = useContext(GameDocumentContext);

  const theme = React.useMemo(() => gameDocument.theme, [gameDocument.theme]);

  const fontFamily: string = theme?.fontFamily ?? '';
  const color: Color[] = theme?.colors ?? [];
  const primaryColor: string =
    color.find((x) => x.type === 'Primary')?.color ?? '';
  const secondaryColor: string =
    color.find((x) => x.type === 'Secondary')?.color ?? '';
  const warningColor: string =
    color.find((x) => x.type === 'Warning')?.color ?? '';
  const successColor: string =
    color.find((x) => x.type === 'Success')?.color ?? '';
  const iconScale: string = React.useMemo(() => {
    if (!theme?.iconScale) return '75px';

    switch (theme.iconScale) {
      case 'sm':
        return '75px';
      case 'md':
        return '125px';
      case 'lg':
        return '200px';
    }
  }, [theme?.iconScale]);

  return (
    <>
      {fontFamily !== undefined && fontFamily !== '' && (
        <style type={'text/css'}>
          {`
            body { --bs-body-font-family: ${fontFamily}} 
            .k-button-text { font-family: ${fontFamily}}
            .k-message { font-family: ${fontFamily}}
            .k-timestamp { font-family: ${fontFamily}}
            .k-message-box { font-family: ${fontFamily}}`}
        </style>
      )}

      {primaryColor && (
        <style type={'text/css'}>{`
        .k-button--gradient { background: ${primaryColor} !important; }
        .border-primary { border-color: ${primaryColor} !important; }
        .text-primary { color: ${primaryColor} !important; }  
        .k-button-solid-primary:focus { box-shadow: 0 0 0px 0.25rem ${primaryColor.replace(
          '1)',
          '0.5)'
        )} !important; }
        .k-button-solid-primary { border-color: ${primaryColor} !important; color: ${getContrastingTextColor(primaryColor)} !important; }
        .content__header { background-color: ${primaryColor} !important; color: ${getContrastingTextColor(primaryColor)} !important; }
        `}</style>
      )}

      {secondaryColor && (
        <style type={'text/css'}>{`
        .border-secondary { border-color: ${secondaryColor} !important; }
        .text-secondary { color: ${secondaryColor} !important; }  
        `}</style>
      )}

      {successColor && (
        <style type={'text/css'}>{`
        .border-success { border-color: ${successColor} !important; }
        .text-success { color: ${successColor} !important; }  
        `}</style>
      )}

      {warningColor && (
        <style type={'text/css'}>{`
        .border-danger { border-color: ${warningColor} !important; }
        .text-danger { color: ${warningColor} !important; }  
        `}</style>
      )}

      {iconScale && (
        <style type={'text/css'}>
          {`
              .player-container,
              .task-container {
                border-radius: ${iconScale} !important;
                .avatar-container,
                .icon-container {
                  .avatar-circle,
                  .icon-circle {
                    .avatar-img,
                    .icon-img {
                      height: ${iconScale} !important;
                      width: ${iconScale} !important;
                    }
                  }
                }
              }
              `}
        </style>
      )}
    </>
  );
};

export default Theme;
